export default "__VITE_ASSET__7dFxbLJX__"